import { lazyNamed } from 'src/utils/lazyNamed.ts';

export const SupportCenter = {
  Tickets: lazyNamed(() => import('./pages/Tickets/index.tsx'), 'Tickets'),
  TicketForm: lazyNamed(() => import('./pages/TicketForm/index.tsx'), 'TicketForm'),
  TicketOverview: lazyNamed(() => import('./pages/TicketOverview/index.tsx'), 'TicketOverview'),
};
